import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_URL || 'http://localhost:5000/api';

const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
    },
});

// Add auth token to requests if available
api.interceptors.request.use((config) => {
    const token = localStorage.getItem('token');
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
});


/**
 * Get all experiences with pagination
 */
export const getAllExperiences = async (params = {}) => {
    try {
        const response = await api.get('/experiences', { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching experiences:', error);
        throw error;
    }
};

/**
 * Search experiences with filters
 */
export const searchExperiences = async (filters = {}) => {
    try {
        const response = await api.get('/experiences/search', { params: filters });
        return response.data;
    } catch (error) {
        console.error('Error searching experiences:', error);
        throw error;
    }
};

/**
 * Get experience by ID
 */
export const getExperienceById = async (id) => {
    try {
        const response = await api.get(`/experiences/${id}`);
        return response.data;
    } catch (error) {
        console.error('Error fetching experience:', error);
        throw error;
    }
};

/**
 * Get experiences by category
 */
export const getExperiencesByCategory = async (category, params = {}) => {
    try {
        const response = await api.get(`/experiences/category/${category}`, { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching experiences by category:', error);
        throw error;
    }
};

/**
 * Get experiences by location
 */
export const getExperiencesByLocation = async (country, params = {}) => {
    try {
        const response = await api.get(`/experiences/location/${country}`, { params });
        return response.data;
    } catch (error) {
        console.error('Error fetching experiences by location:', error);
        throw error;
    }
};

/**
 * Get featured experiences
 */
export const getFeaturedExperiences = async (limit = 6) => {
    try {
        const response = await api.get('/experiences/featured/list', { params: { limit } });
        return response.data;
    } catch (error) {
        console.error('Error fetching featured experiences:', error);
        throw error;
    }
};

/**
 * Get all categories
 */
export const getCategories = async () => {
    try {
        const response = await api.get('/experiences/categories');
        return response.data;
    } catch (error) {
        console.error('Error fetching categories:', error);
        throw error;
    }
};

/**
 * Get all countries
 */
export const getCountries = async () => {
    try {
        const response = await api.get('/experiences/countries');
        return response.data;
    } catch (error) {
        console.error('Error fetching countries:', error);
        throw error;
    }
};

/**
 * Get location autocomplete suggestions
 */
export const getLocationAutocomplete = async (query) => {
    try {
        // This would need to be implemented on the backend if needed
        // For now, returning empty array
        return [];
    } catch (error) {
        console.error('Error fetching location autocomplete:', error);
        throw error;
    }
};

export default {
    getAllExperiences,
    searchExperiences,
    getExperienceById,
    getExperiencesByCategory,
    getExperiencesByLocation,
    getFeaturedExperiences,
    getCategories,
    getCountries,
    getLocationAutocomplete,
};
